import { z } from "zod/v4";

import { RuleTargetingDescriptions } from "../descriptions/targeting-dto.describe";
import { assertDescriptions } from "../descriptions/types";

import { CartTargetingNode } from "./cart-targeting";
import { ProductTargetingExpressionNode } from "./experience-product-targeting";

// A targeting predicate embedded in its owner (e.g. a component rule),
// discriminated on `type`. Each domain reuses its existing node schema so the
// platform evaluators run unchanged. Onsite upsells only author cart/product.
const CartRuleTargetingSchema = z.object({
  type: z.literal("cart").describe(RuleTargetingDescriptions.type),
  expression: z
    .array(CartTargetingNode)
    .describe(RuleTargetingDescriptions.expression),
});

const ProductRuleTargetingSchema = z.object({
  type: z.literal("product").describe(RuleTargetingDescriptions.type),
  expression: z
    .array(ProductTargetingExpressionNode)
    .describe(RuleTargetingDescriptions.expression),
});

export const RuleTargetingSchema = z.discriminatedUnion("type", [
  CartRuleTargetingSchema,
  ProductRuleTargetingSchema,
]);

export type RuleTargeting = z.infer<typeof RuleTargetingSchema>;

// Compile-time check: description object must cover all RuleTargeting keys.
assertDescriptions<
  typeof RuleTargetingDescriptions,
  z.infer<typeof CartRuleTargetingSchema>
>();
